module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid col-sm-12 col-xs-12 ls-no-padding"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('flash-message'), _vm._v(" "), _c('form', {
    staticClass: "ls-form",
    on: {
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
      },
      "submit": function($event) {
        $event.preventDefault();
        _vm.doActions()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ls-float-right col-md-12 col-xs-12 col-sm-12 ls-no-padding-left ls-md-margin-bottom"
  }, [_c('div', {
    class: ['ls-collapse', _vm.showCollapse ? 'ls-collapse-opened' : ''],
    attrs: {
      "data-ls-module": "collapse"
    }
  }, [_c('div', {
    staticClass: "ls-collapse-header",
    on: {
      "click": function($event) {
        _vm.toogleCollapse()
      }
    }
  }, [_c('h4', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('contracts.labels.contract_settings')))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-collapse-body",
    attrs: {
      "id": "30"
    }
  }, [_c('div', {
    staticClass: "row d-flex flex-wrap"
  }, [_c('div', {
    staticClass: "col-lg-12 ls-display-flex flex-wrap-wrap align-itens-end"
  }, [_c('div', {
    staticClass: "col-lg-3 col-xs-12 ls-no-padding"
  }, [_c('label', {
    staticClass: "ls-label"
  }, [_c('b', {
    staticClass: "ls-label-text ls-xs-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.settings.days_to_overdue_invoice')) + "\n                      "), _c('popover', {
    attrs: {
      "position": 'right'
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v(_vm._s(_vm.$t('contracts.new.popover.days_to_overdue_invoice')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-xs-2 ls-no-padding"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.days_to_overdue_invoice.value),
      expression: "settings.days_to_overdue_invoice.value"
    }],
    staticClass: "ls-field-sm",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.settings.days_to_overdue_invoice.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.days_to_overdue_invoice.value = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('contracts.attributes.day_expiration'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text ls-xs-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.day_expiration')))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-xs-2 ls-no-padding"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|valid_dd'),
      expression: "'required|valid_dd'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contract_params.day_expiration),
      expression: "contract_params.day_expiration"
    }],
    staticClass: "ls-field-sm",
    attrs: {
      "type": "number",
      "data-test": "'contracts.attributes.day_expiration'",
      "min": "1",
      "max": "31",
      "name": _vm.$t('contracts.attributes.day_expiration')
    },
    domProps: {
      "value": (_vm.contract_params.day_expiration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract_params.day_expiration = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('contracts.attributes.day_expiration'))),
      expression: "errors.has($t('contracts.attributes.day_expiration'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('contracts.attributes.day_expiration'))))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('contracts.attributes.url_notification'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text ls-xs-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.url_notification')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract_params.url_notification),
      expression: "contract_params.url_notification"
    }],
    staticClass: "ls-field-sm",
    attrs: {
      "type": "text",
      "data-test": "'contracts.attributes.url_notification'",
      "placeholder": _vm.$t('contracts.placeholder.url_notification'),
      "name": _vm.$t('contracts.attributes.url_notification')
    },
    domProps: {
      "value": (_vm.contract_params.url_notification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract_params.url_notification = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('contracts.attributes.url_notification'))),
      expression: "errors.has($t('contracts.attributes.url_notification'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('contracts.attributes.url_notification'))))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 ls-no-padding"
  }, [_c('div', {
    staticClass: "col-lg-6 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.generate_service_tax_invoices.value),
      expression: "settings.generate_service_tax_invoices.value"
    }],
    staticClass: "ls-float-left",
    attrs: {
      "type": "checkbox",
      "name": "settings.generate_service_tax_invoices.value"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.generate_service_tax_invoices.value) ? _vm._i(_vm.settings.generate_service_tax_invoices.value, null) > -1 : (_vm.settings.generate_service_tax_invoices.value)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settings.generate_service_tax_invoices.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.settings.generate_service_tax_invoices.value = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.settings.generate_service_tax_invoices.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settings.generate_service_tax_invoices.value = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_c('p', [_c('span', {
    staticClass: "txt-check"
  }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.settings.generate_service_tax_invoices')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-xs-12"
  }, [_c('authorized-link', {
    attrs: {
      "tag": "index_contract_tax"
    }
  }, [_c('button', {
    staticClass: "ls-btn ls-btn-primary ls-no-margin ls-float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openTaxesModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-usd",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('contracts.edit.manage_taxes')))])])])], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('contracts.edit.contract_plans')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('authorized-link', {
    attrs: {
      "tag": "create_contract_plan"
    }
  }, [_c('div', {
    staticClass: " col-md-12 col-sm-12 col-xs-12 ls-no-padding"
  }, [_c('button', {
    staticClass: "ls-btn ls-btn-primary ls-no-margin ls-float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addPlan($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "ls-xs-margin-left"
  }, [_vm._v(_vm._s(_vm.$t('application.button.add_plan')))])])])])], 1)])]), _vm._v(" "), _vm._l((_vm.contractPlans.length), function(index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12 col-lg-12 col-xs-12 col-md-12 ls-box-filter ls-xs-space",
      attrs: {
        "id": index
      }
    }, [_c('fieldset', [_c('div', {
      staticClass: "col-md-12",
      class: _vm.pageWidth > 1300 ? 'd-flex' : '',
      attrs: {
        "data-vv-scope": index
      }
    }, [_c('label', {
      staticClass: "ls-no-padding col-md-12 col-xs-12",
      class: {
        'ls-error': _vm.errors.has(index.toString() + '.' + _vm.$t('contracts.plan'))
      }
    }, [(_vm.contractPlans[index - 1].changeable === undefined) ? _c('v-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      ref: index,
      refInFor: true,
      staticClass: "ls-sm-margin-bottom",
      attrs: {
        "closeOnSelect": true,
        "label": "name",
        "transition": "none",
        "data-vv-scope": index,
        "placeholder": _vm.$t('contracts.placeholder.search_by_plan_name'),
        "options": _vm.plansOptions,
        "value": _vm.contractPlans[(index - 1)]
      },
      on: {
        "search": _vm.onSearchPlan,
        "input": function($event) {
          _vm.changedLabel($event, (index - 1))
        },
        "update:value": function($event) {
          var $$exp = _vm.contractPlans,
            $$idx = (index - 1);
          if (!Array.isArray($$exp)) {
            _vm.contractPlans[(index - 1)] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      },
      nativeOn: {
        "input": function($event) {
          _vm.clearFilter($event)
        }
      },
      model: {
        value: (_vm.contractPlans[(index - 1)].plan),
        callback: function($$v) {
          _vm.contractPlans[(index - 1)].plan = $$v
        },
        expression: "contractPlans[(index - 1)].plan"
      }
    }, [_c('template', {
      slot: "no-options"
    }, [_vm._v(_vm._s(_vm.$t('contracts.new.find_plan')))])], 2) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contractPlans[(index - 1)].plan.name),
        expression: "contractPlans[(index - 1)].plan.name"
      }],
      staticClass: "col-md-12 col-sm-12 col-xs-12 ls-sm-margin-bottom",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": ""
      },
      domProps: {
        "value": (_vm.contractPlans[(index - 1)].plan.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.contractPlans[(index - 1)].plan.name = $event.target.value
        }
      }
    }), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has(index.toString() + '.' + _vm.$t('contracts.plan'))),
        expression: "errors.has(index.toString() + '.' + $t('contracts.plan'))"
      }],
      staticClass: "ls-help-message"
    }, [_vm._v(_vm._s(_vm.errors.first(index.toString() + '.' + _vm.$t('contracts.plan'))))])], 1), _vm._v(" "), (_vm.contractPlansLength > 1 || _vm.contractPlans[index - 1].deleted) ? _c('div', {
      staticClass: "col-md-12 ls-no-padding ls-no-margin-top"
    }, [_c('button', {
      staticClass: "ls-btn ls-btn-danger ls-float-right  ls-no-margin",
      attrs: {
        "type": "button",
        "id": 'button' + index
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.tooglePlan(index - 1)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('contract_plans.buttons.inactivate')))])]) : _vm._e()]), _vm._v(" "), (_vm.contractPlans[(index - 1)].plan) ? _c('div', {
      staticClass: "container-fluid"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "no-wrap col-md-12 col-lg-12 ls-no-padding"
    }, [_c('div', {
      staticClass: "col-xlg-1 col-lg-1-5 col-xs-6 ls-no-padding-right"
    }, [_c('label', {
      staticClass: "ls-label",
      class: {
        'ls-error': _vm.errors.has(index.toString() + '.' + _vm.$t('plans.attributes.periodicity'))
      }
    }, [_c('span', {
      staticClass: "ls-label-text col-xs-12 ls-sm-margin-bottom ls-no-padding"
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('contracts.new.periodicity')) + "\n                      "), _c('popover', {
      attrs: {
        "position": 'right'
      }
    }, [_c('div', {
      slot: "content"
    }, [_vm._v(_vm._s(_vm.$t('contracts.labels.periodicity')))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-6 col-lg-6 ls-no-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contractPlans[(index - 1)].periodicity),
        expression: "contractPlans[(index - 1)].periodicity"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|decimal:0|min_value:1'),
        expression: "'required|decimal:0|min_value:1'"
      }],
      attrs: {
        "type": "number",
        "min": "0",
        "max": "48",
        "step": "1",
        "required": "",
        "name": "plans.attributes.periodicity",
        "name": _vm.$t('plans.attributes.periodicity'),
        "data-vv-scope": index
      },
      domProps: {
        "value": (_vm.contractPlans[(index - 1)].periodicity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.contractPlans[(index - 1)].periodicity = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has(index.toString() + '.' + _vm.$t('plans.attributes.periodicity'))),
        expression: "errors.has(index.toString() + '.' + $t('plans.attributes.periodicity'))"
      }],
      staticClass: "ls-help-message"
    }, [_vm._v(_vm._s(_vm.errors.first(index.toString() + '.' + _vm.$t('plans.attributes.periodicity'))))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-1 col-lg-1-5 col-xs-6"
    }, [_c('label', {
      staticClass: "ls-label"
    }, [_c('span', {
      staticClass: "ls-label-text ls-sm-margin-bottom d-flex"
    }, [_vm._v("Qtde Lançada")]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-5 col-xlg-6 ls-no-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contractPlans[index - 1].quantity_launched),
        expression: "contractPlans[index - 1].quantity_launched"
      }],
      attrs: {
        "type": "number",
        "disabled": ""
      },
      domProps: {
        "value": (_vm.contractPlans[index - 1].quantity_launched)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.contractPlans[index - 1].quantity_launched = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-1 col-lg-1-5 col-xs-6"
    }, [_c('label', {
      staticClass: "ls-label",
      class: {
        'ls-error': _vm.errors.has(index.toString() + '.' + _vm.$t('plans.attributes.quantity'))
      }
    }, [_c('span', {
      staticClass: "ls-label-text col-xs-12 ls-sm-margin-bottom ls-no-padding ls-sm-padding-rigth d-flex"
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('contracts.new.quantity')) + "\n                      "), _c('popover', {
      staticClass: "margin-left-3px",
      attrs: {
        "position": 'right'
      }
    }, [_c('div', {
      slot: "content"
    }, [_vm._v(_vm._s(_vm.$t('contracts.labels.quantity')))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-lg-5 col-xlg-6 ls-no-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contractPlans[(index - 1)].quantity),
        expression: "contractPlans[(index - 1)].quantity"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true,
          max_quantity: [],
          decimal: 0,
          valid_quantity: [_vm.contractPlans[(index - 1)].quantity_launched, _vm.contractPlans[index - 1].original_quantity]
        }),
        expression: "{ required: true, max_quantity: [], decimal: 0, valid_quantity: [contractPlans[(index - 1)].quantity_launched, contractPlans[index - 1].original_quantity] }"
      }],
      attrs: {
        "type": "number",
        "min": "0",
        "step": "1",
        "required": "",
        "name": "plans.attributes.quantity",
        "data-vv-scope": index,
        "name": _vm.$t('plans.attributes.quantity')
      },
      domProps: {
        "value": (_vm.contractPlans[(index - 1)].quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.contractPlans[(index - 1)].quantity = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has(index.toString() + '.' + _vm.$t('plans.attributes.quantity'))),
        expression: "errors.has(index.toString() + '.' + $t('plans.attributes.quantity'))"
      }],
      staticClass: "ls-help-message"
    }, [_vm._v(_vm._s(_vm.errors.first(index.toString() + '.' + _vm.$t('plans.attributes.quantity'))))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-xlg-2 col-xs-6 ls-no-padding-left"
    }, [_c('label', {
      staticClass: "ls-label",
      class: {
        'ls-error': _vm.errors.has(index.toString() + '.' + _vm.$t('plans.attributes.price'))
      }
    }, [_c('b', {
      staticClass: "ls-label-text ls-sm-margin-bottom"
    }, [_vm._v(_vm._s(_vm.$t('plans.new.value')))]), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-8"
    }, [_c('money-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|onlyPositive'),
        expression: "'required|onlyPositive'"
      }],
      attrs: {
        "value": _vm.contractPlans[(index - 1)].price,
        "required": "",
        "step": "2",
        "name": _vm.$t('plans.attributes.price'),
        "data-vv-scope": index
      },
      on: {
        "updateValue": function (value) {
          _vm.contractPlans[(index - 1)].price = value
        }
      },
      model: {
        value: (_vm.contractPlans[(index - 1)].price),
        callback: function($$v) {
          _vm.contractPlans[(index - 1)].price = $$v
        },
        expression: "contractPlans[(index - 1)].price"
      }
    })], 1), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has(index.toString() + '.' + _vm.$t('plans.attributes.price'))),
        expression: "errors.has(index.toString() + '.' + $t('plans.attributes.price'))"
      }],
      staticClass: "ls-help-message"
    }, [_vm._v(_vm._s(_vm.errors.first(index.toString() + '.' + _vm.$t('plans.attributes.price'))))])])]), _vm._v(" "), _c('authorized-link', {
      attrs: {
        "tag": "update_contract_plan_entry"
      }
    }, [_c('div', {
      staticClass: "col-lg-1-5 col-xlg-1 col-xs-6"
    }, [_c('label', {
      staticClass: "ls-label"
    }, [_c('span', {
      staticClass: "ls-label-text ls-sm-margin-bottom"
    }, [_vm._v("Desc Lançados")]), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-4 col-lg-6 ls-no-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contractPlans[index - 1].contract_plan_entries[0].quantity_launched),
        expression: "contractPlans[index - 1].contract_plan_entries[0].quantity_launched"
      }],
      attrs: {
        "type": "number",
        "disabled": ""
      },
      domProps: {
        "value": (_vm.contractPlans[index - 1].contract_plan_entries[0].quantity_launched)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.contractPlans[index - 1].contract_plan_entries[0].quantity_launched = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-1 col-lg-1-5 col-xs-6 ls-no-padding"
    }, [_c('label', {
      staticClass: "ls-label ls-no-padding-left",
      class: {
        'ls-error': _vm.errors.has(index.toString() + '.' + _vm.$t('contracts.new.discount_quantity'))
      }
    }, [_c('span', {
      staticClass: "ls-label-text ls-sm-margin-bottom d-flex"
    }, [_vm._v(_vm._s(_vm.$t('contracts.new.discount_quantity')) + "\n                        "), _c('popover', {
      staticClass: "margin-left-3px",
      attrs: {
        "position": 'right'
      }
    }, [_c('div', {
      staticClass: "ls-xs-margin-left",
      slot: "content"
    }, [_vm._v(_vm._s(_vm.$t('contracts.labels.discount_quantity')))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-6 col-lg-6 ls-no-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contractPlans[(index - 1)].contract_plan_entries[0].quantity),
        expression: "contractPlans[(index - 1)].contract_plan_entries[0].quantity"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true,
          decimal: 0,
          max_quantity: [],
          valid_quantity: [_vm.contractPlans[(index - 1)].contract_plan_entries[0].quantity_launched, _vm.contractPlans[index - 1].contract_plan_entries[0].original_quantity]
        }),
        expression: "{ required: true ,decimal: 0, max_quantity: [], valid_quantity: [contractPlans[(index - 1)].contract_plan_entries[0].quantity_launched, contractPlans[index - 1].contract_plan_entries[0].original_quantity] }"
      }],
      attrs: {
        "type": "number",
        "required": "",
        "min": "0",
        "name": _vm.$t('contracts.new.discount_quantity'),
        "data-vv-scope": index,
        "placeholder": _vm.$t('contracts.new.discount_quantity')
      },
      domProps: {
        "value": (_vm.contractPlans[(index - 1)].contract_plan_entries[0].quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.contractPlans[(index - 1)].contract_plan_entries[0].quantity = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has(index.toString() + '.' + _vm.$t('contracts.new.discount_quantity'))),
        expression: "errors.has(index.toString() + '.' + $t('contracts.new.discount_quantity'))"
      }],
      staticClass: "ls-help-message"
    }, [_vm._v(_vm._s(_vm.errors.first(index.toString() + '.' + _vm.$t('contracts.new.discount_quantity'))))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-2 col-lg-2 col-xs-12"
    }, [_c('label', {
      staticClass: "ls-label",
      class: {
        'ls-error': _vm.errors.has(index.toString() + '.' + _vm.$t('contracts.new.discount_price'))
      }
    }, [_c('b', {
      staticClass: "ls-label-text ls-sm-margin-bottom"
    }, [_vm._v(_vm._s(_vm.$t('contracts.new.discount_price')))]), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-8"
    }, [_c('money-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|onlyPositive'),
        expression: "'required|onlyPositive'"
      }],
      attrs: {
        "value": _vm.contractPlans[(index - 1)].contract_plan_entries[0].price,
        "data-vv-scope": index,
        "name": _vm.$t('contracts.new.discount_price')
      },
      on: {
        "updateValue": function (value) {
          _vm.contractPlans[(index - 1)].contract_plan_entries[0].price = value
        }
      },
      model: {
        value: (_vm.contractPlans[(index - 1)].contract_plan_entries[0].price),
        callback: function($$v) {
          _vm.contractPlans[(index - 1)].contract_plan_entries[0].price = $$v
        },
        expression: "contractPlans[(index - 1)].contract_plan_entries[0].price"
      }
    })], 1), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has(index.toString() + '.' + _vm.$t('contracts.new.discount_price'))),
        expression: "errors.has(index.toString() + '.' + $t('contracts.new.discount_price'))"
      }],
      staticClass: "ls-help-message"
    }, [_vm._v(_vm._s(_vm.errors.first(index.toString() + '.' + _vm.$t('contracts.new.discount_price'))))])])])])], 1)])]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "ls-btn-primary ls-float-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.redirectToContract()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "ls-xs-margin-left"
  }, [_vm._v(_vm._s(_vm.$t('contracts.buttons.come_back')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 ls-no-padding"
  }, [_c('button', {
    staticClass: "ls-btn-primary ls-float-right",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "ls-xs-margin-left"
  }, [_vm._v(_vm._s(_vm.$t('contracts.buttons.save')))])])])])], 2), _vm._v(" "), _c('modal-confirm-changes', {
    model: {
      value: (_vm.confirmChanges),
      callback: function($$v) {
        _vm.confirmChanges = $$v
      },
      expression: "confirmChanges"
    }
  }), _vm._v(" "), _c('modal-taxes', {
    attrs: {
      "linkedTaxes": _vm.linkedTaxes,
      "unlinkedTaxes": _vm.unlinkedTaxes,
      "save": true
    },
    model: {
      value: (_vm.modalTaxes),
      callback: function($$v) {
        _vm.modalTaxes = $$v
      },
      expression: "modalTaxes"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e35b4ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/contracts/Edit.vue
// module id = 813
// module chunks = 1